import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'

export const useUnsavedChangesAlert = (hasUnsavedChanges: boolean) => {
  const blocker = useBlocker(hasUnsavedChanges)

  useEffect(() => {
    if (!hasUnsavedChanges) {
      blocker.reset?.()
      return
    }

    if (blocker.state === 'blocked') {
      if (window.confirm('Möchtest du wirklich die Seite wechseln? Deine Änderungen gehen dadurch verloren.')) {
        blocker.proceed?.()
      } else {
        blocker.reset?.()
      }
    }
  }, [blocker, hasUnsavedChanges])
}
